import Spacer from '@antimatterhq/ui/components/spacer';
import { Paragraph, Text } from '@antimatterhq/ui/components/typography';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FlagSet } from '@antimatterhq/ui/utils/flags';
import Alerts from './_partials/Alerts';
import { ObservableRelationships } from './_partials/ObservableRelationships';
import { DetectionCategories } from './_partials/DetectionCategories';
import { ObservableKinds } from './_partials/ObservableKinds';
import ManagedRetention from './_partials/ManagedRetention';
import { Workspace } from './_partials/Workspace';
import { TwoColumnLayout } from '@/components/container';
import { TableOfContentsProvider } from '@/contexts/TableOfContentContext';
import { TocWrapper } from '@/components/tableOfContents/ToCWrapper';
import { TableOfContents } from '@/components/tableOfContents/TableOfContents';
import { CustomPresets } from '@/pages/configure/workspace/_partials/CustomPresets';

export default function WorkspacePage() {
  const { enableManagedRetention } = useFlags<FlagSet>();

  return (
    <TableOfContentsProvider>
      <Text size="2xl" bold>
        Workspace config
      </Text>
      <Spacer size="lg" />
      <TwoColumnLayout.Root>
        <TwoColumnLayout.LeftColumn>
          <TocWrapper
            name="detection-categories"
            displayName="Detection categories"
          >
            <Text size="xl" bold>
              Detection categories
            </Text>

            <Spacer size="base" />

            <Paragraph>
              The list of detection categories that a user can select from when
              making a rule
            </Paragraph>

            <Spacer size="lg" />

            <DetectionCategories />
          </TocWrapper>

          <Spacer size="2xl" />
          <div className="-mr-8 h-px bg-gray-300" />
          <Spacer size="2xl" />

          <TocWrapper name="observable-kinds" displayName="Observable kinds">
            <Text size="xl" bold>
              Observable kinds
            </Text>

            <Spacer size="base" />

            <Paragraph>Key Attributes to track in security events</Paragraph>

            <Spacer size="base" />

            <ObservableKinds />
          </TocWrapper>

          <Spacer size="2xl" />
          <div className="-mr-8 h-px bg-gray-300" />
          <Spacer size="2xl" />

          <TocWrapper
            name="observable-relationships"
            displayName="Observable relationships"
          >
            <Text size="xl" bold>
              Observable relationships
            </Text>

            <Spacer size="base" />

            <Paragraph>
              Observable types that may be noteworthy security events
            </Paragraph>

            <Spacer size="base" />

            <ObservableRelationships />
          </TocWrapper>

          {enableManagedRetention && (
            <>
              <Spacer size="2xl" />
              <div className="-mr-8 h-px bg-gray-300" />
              <Spacer size="2xl" />

              <TocWrapper
                name="Managed retention"
                displayName="Managed retention"
              >
                <Text size="xl" bold>
                  Managed retention
                </Text>

                <Spacer size="base" />

                <Paragraph>Schemas on which to manage retention</Paragraph>

                <Spacer size="base" />

                <ManagedRetention />
              </TocWrapper>
            </>
          )}

          <Spacer size="2xl" />
          <div className="-mr-8 h-px bg-gray-300" />
          <Spacer size="2xl" />

          <TocWrapper name="workspace" displayName="Workspace organization">
            <Text size="xl" bold>
              Workspace organization
            </Text>

            <Spacer size="base" />

            <Workspace />
          </TocWrapper>

          <Spacer size="2xl" />
          <div className="-mr-8 h-px bg-gray-300" />
          <Spacer size="2xl" />

          <TocWrapper
            name="alert-exports"
            displayName="Notable & operational alert export configuration"
          >
            <Text size="xl" bold className="mt-4">
              Notable & operational alert export configuration
            </Text>

            <Spacer size="base" />

            <Alerts />
          </TocWrapper>

          <Spacer size="2xl" />
          <div className="-mr-8 h-px bg-gray-300" />
          <Spacer size="2xl" />

          <TocWrapper name="paths" displayName="Custom presets">
            <Text size="xl" bold>
              Custom presets
            </Text>

            <Spacer size="base" />

            <CustomPresets />
          </TocWrapper>
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <TableOfContents />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout.Root>
    </TableOfContentsProvider>
  );
}
